export default __webpack_public_path__ + "static/media/ic_tail_24.723c57cd.svg";